import React from 'react';
export function AboutStory() {
  return <section className="py-20 bg-[#111]" data-id="element-450">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-451">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-452">
          <div className="relative animate-scroll-fade-up" data-id="element-453">
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-[#00D4FF]/20 rounded-full blur-2xl" data-id="element-454" />
            <img src="https://cdn.magicpatterns.com/uploads/p16qSsFXr1o9UMn6JvwfAQ/mayor_brady.jpg" alt="Walker's Martial Arts team with Mayor" className="relative rounded-2xl shadow-2xl z-10" data-id="element-455" />
            <div className="absolute -bottom-6 -right-6 w-full h-full border-2 border-[#00D4FF]/30 rounded-2xl z-0" data-id="element-456" />
          </div>

          <div className="animate-scroll-fade-up" style={{
          animationDelay: '0.15s'
        }} data-id="element-457">
            <h2 className="text-3xl font-bold text-white mb-6" data-id="element-458">Our Story</h2>
            <div className="space-y-6 text-gray-300 text-lg leading-relaxed" data-id="element-459">
              <p data-id="element-460">
                Founded in 1999, Walker's Martial Arts began with a simple
                mission: to create a space where anyone, regardless of age or
                ability, could discover their inner strength.
              </p>
              <p data-id="element-461">
                Grandmaster Joe Walker, a 7th Degree Black Belt, built this
                academy on the principles of traditional martial arts while
                adapting to the needs of modern families. What started as a
                small studio has grown into Bloomington's premier martial arts
                facility.
              </p>
              <p data-id="element-462">
                Today, we are proud to have served thousands of families in our
                community, helping students build confidence, discipline, and
                physical fitness that lasts a lifetime in our state-of-the-art
                4,200 sq ft facility.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}